import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2Issue } from '@/api/model/interfaces';

export default class PackageKS2IssueOdata extends OdataManager<PackageKS2Issue> {}
